import Vue from 'vue';

const success = (res, resolve) => {
  resolve(res);
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (params) => {
  const data = new FormData();
  data.append('percentage', params.percentage);
  data.append('enable_rounding', params.enableRounding);
  data.append('rounding_type', params.roundingType);
  data.append('price_type', params.priceType);

  return new Promise((resolve, reject) => {
    Vue.$http
      .request({
        url: '/settings/advance/bulk_price_update',
        data,
        method: 'post',
      })
      .then((res) => {
        success(res, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  });
};




// WEBPACK FOOTER //
// ./src/app/services/advance/bulkPriceUpdate.js